import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "" }, "IGNOROVANÉ EMAILY")
], -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "mr-2",
  for: "email"
}, "Pridať ignorovaný email", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitIgnoredEmail && $options.submitIgnoredEmail(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          class: "w-6",
          modelValue: this.ignoredEmail.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.ignoredEmail.email) = $event)),
          type: "text",
          name: "email",
          id: "email"
        }, null, 8, ["modelValue"])
      ])
    ], 32),
    _createVNode(_component_DataTable, {
      scrollable: "",
      scrollHeight: `${this.vh - 300}px`,
      value: this.ignoredEmails,
      stripedRows: "",
      "row-hover": "",
      editingRows: $data.editingRows,
      "onUpdate:editingRows": _cache[2] || (_cache[2] = ($event: any) => (($data.editingRows) = $event)),
      editMode: "row",
      dataKey: "id",
      onRowEditSave: $options.submitIgnoredEmail,
      tableStyle: "width: 100%",
      virtualScrollerOptions: { itemSize: 35 }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "id",
          header: "ID",
          style: {"min-width":"10%"}
        }),
        _createVNode(_component_Column, {
          field: "email",
          header: "Email",
          style: {"min-width":"50%"}
        }, {
          editor: _withCtx(({ data, field }) => [
            _createVNode(_component_InputText, {
              modelValue: data[field],
              "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          rowEditor: true,
          style: {"width":"3%","min-width":"3rem"},
          bodyStyle: "text-align:center"
        }),
        _createVNode(_component_Column, { header: "" }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_PrimevueButton, {
              type: "button",
              icon: "pi pi-trash",
              onClick: ($event: any) => ($options.deleteIgnoredEmail(slotProps.data.id)),
              text: "",
              severity: "danger",
              size: "small"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["scrollHeight", "value", "editingRows", "onRowEditSave"])
  ]))
}